/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React,{useRef, useState} from 'react'
import { useOnClickOutside } from '../../CommonMethods/OutsideClick'

export default function ToolTip({name,id}) {
    const ref =useRef()
    const [show, setshow] = useState(false)
    useOnClickOutside(ref,()=>{
        setshow(false)

    })
    return (
       

        <div                
            ref={ref}

            className="relative flex items-center pb-1.5" 
        >
            <label htmlFor="uploadGST" className="text-f1 font-medium text-[#344054] ">{name}</label>
            <div className="relative h-4">
                <button
                    onClick={()=>setshow(!show)}
                    data-tooltip-target="gstuploadInfo" data-tooltip-trigger="click"  data-tooltip-placement="top" type="button" className="ml-[5px] h-4">
                    <img 
                        loading="lazy" decoding="async" src="/images/InfoIcon.svg" alt="img" />
                </button>
                <motion.div 
                    id="gstuploadInfo"
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0 }}
                    role="tooltip" 
                    className={`absolute left-[28px] bottom-[-3px] w-max z-10 ${show?'visible':'invisible'} inline-block left-[117px] text-[10px] leading-[18px] font-normal text-[#031624] px-1.5 py-1 bg-[#E6E8EA] rounded-[5px]`}
                >
                    Upload a JPEG,PNG or PDF File with a Maximum Size of 10 MB
                    <div className="tooltip-arrow" data-popper-arrow></div>
                </motion.div>
            </div>
        </div>
    )
}
